import React, { useState } from 'react';
import useNotificaciones from '../../hooks/useNotificaciones';
import NotificationCenter from '../NotificationCenter/NotificationCenter';
import './NotificationButton.css';

/**
 * Botón de notificaciones para el Navbar
 * Muestra el contador de notificaciones no leídas y abre el centro de notificaciones
 */
const NotificationButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { noLeidas } = useNotificaciones(true); // Auto-fetch habilitado

  const toggleNotifications = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button 
        className="notification-button"
        onClick={toggleNotifications}
        title="Ver notificaciones"
      >
        🔔
        {noLeidas > 0 && (
          <span className="notification-count">{noLeidas > 99 ? '99+' : noLeidas}</span>
        )}
      </button>

      <NotificationCenter 
        isOpen={isOpen} 
        onClose={() => setIsOpen(false)} 
      />
    </>
  );
};

export default NotificationButton;
